// 这是一神奇的容器组件，当它存在于页面上的时候，会拦截鼠标在容器之外任意地方的点击事件，并发出 cancel 事件

const __script_base__ = {
  name: 'GlobalClickGuard',
  props: {
    tagName: {
      type: String,
      default: 'div'
    },
    // up和down 对应鼠标mousedown/mouseup ,对应touchstart/touchend
    listenEvent: {
      type: String,
      default: 'up'
    },
    guardEnable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listenerAdded: false
    };
  },
  beforeDestroy() {
    this.removeListener();
  },
  mounted() {
    this.addListener();
  },
  computed: {
    mouseEventName() {
      return `mouse${this.listenEvent}`;
    },
    touchEventName() {
      return {
        up: 'touchend',
        down: 'touchstart'
      }[this.listenEvent];
    }
  },
  methods: {
    addListener() {
      if (this.listenerAdded) return;
      window.document.addEventListener(this.mouseEventName, this.globalClickListener, true);
      window.document.addEventListener(this.touchEventName, this.globalClickListener, true);
      this.listenerAdded = true;
    },
    removeListener() {
      if (!this.listenerAdded) return;
      window.document.removeEventListener(this.mouseEventName, this.globalClickListener, true);
      window.document.removeEventListener(this.touchEventName, this.globalClickListener, true);
      this.listenerAdded = false;
    },
    /** @param {MouseEvent} ev */
    globalClickListener(ev) {
      if (!this.guardEnable) return;
      const content = this.$el;
      if (content === ev.target || content.contains(ev.target)) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      this.$emit('cancel');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tagName, {
    tag: "component"
  }, [_vm._t("default")], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/GlobalClickGuard.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);